import { Typography } from '@mui/material'
import React from 'react'
import { PropsTextFunction } from '../../../styles'

export const SubTitle = (props) => {
  return (
    <Typography
    variant="h5"
    component="h2"
    sx={ PropsTextFunction(props) }
    className={props?.className}
>
    { props?.text }
</Typography>
  )
}
